import React from 'react';
import { Skeleton } from 'antd';

export default function TextSkeleton() {
  return <Skeleton.Input className="!h-5 !w-20" />;
}
